import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import Alert from "./../../common/alert/Alert";
import { Row, Col, FormGroup, FormLabel, FormControl, FormCheck } from "react-bootstrap";
import AppModal from "../../common/modal/AppModal";
import { Typeahead } from "react-bootstrap-typeahead";
import {
  ID_PREFIX_RICH_MARK,
  ID_PREFIX_SORTABLE_BOX,
  ID_PREFIX_CONTAINED_VIEW,
  PAGE_TYPES,
  ID_PREFIX_PAGE,
  ID_PREFIX_BOX,
} from "../../../../common/constants";
import i18n from "i18next";
import { isSection, isContainedView, nextAvailName } from "../../../../common/utils";
import "../rich_marks_modal/_richMarksModal.scss";
import IdealStudio from "../../../../core/editor/main";

import TemplatesModalRich from "../templates_modal/TemplatesModalRich";
import { createBox } from "../../../../common/common_tools";
/**
 * Modal component to edit marks' configuration
 */
export default class UploadTemplateModal extends Component {
  /**
   * Constructor
   * @param props
   */
  constructor(props) {
    super(props);
    /**
     * Component's initial state
     * @type {{connectMode: string, displayMode: string, newSelected: string, existingSelected: string, newType: string, viewNames: *, showAlert: boolean}}
     */
    this.state = {
      connectMode: "new",
      displayMode: "navigate",
      newSelected: this.props.navItems[this.props.navItemSelected]
        ? this.props.navItems[this.props.navItemSelected].type
        : "",
      existingSelected: "",
      templateName: "",
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.toggleTemplatesModal = this.toggleTemplatesModal.bind(this);
    this.templateClick = this.templateClick.bind(this);
  }

  /**
   * Before component receives props
   * Updates component's state with toolbar's state info
   * @param nextProps
   */
  componentWillReceiveProps(nextProps) {}

  /**
   * Render React Component
   * @returns {code}
   */
  render() {
    return (
      <AppModal
        className="richMarksModal"
        backdrop
        show={this.props.visible}
        onClose={() => this.props.onUploadTemplateModalToggled()}
        title={
          <>
            <i style={{ fontSize: "18px" }} className="material-icons">
              brush
            </i>{" "}
            {i18n.t("marks.upload_template")}
          </>
        }
        cancelLabel={i18n.t("Cancel")}
        onCancel={() => this.props.onUploadTemplateModalToggled()}
        confirmLabel={i18n.t("Save")}
        onConfirm={() => {
          if (this.state.templateName.replaceAll(" ", "") == "") {
            this.setState({ showAlert: true, alertMsg: i18n.t("YouMustEnterASceneName") });
            return;
          }
          this.props.onUploadTemplateModalToggled();
          this.props.uploadTemplateFunction(this.state.templateName);
        }}
      >
        {/* <Row>
                        <Col xs={6} md={6}>
                            <FormLabel>{i18n.t("")}</FormLabel>

                        </Col>

                    </Row> */}
        <Row>
          {/* <Col xs={2} md={2}>
                            <FormLabel>{i18n.t("")}</FormLabel>
                        </Col> */}
          <Col xs={12} md={12}>
            <FormControl
              type="text"
              placeholder={i18n.t("WriteYourSceneName")}
              onChange={(e) => this.setState({ templateName: e.target.value })}
            />
          </Col>
        </Row>
        <Row style={{ margin: "0px", padding: "0px" }}>
          {/* <Col xs={2} md={2}></Col> */}
          <Col xs={12} md={12}>
            <p style={{ fontSize: "smaller", padding: "0px", margin: "0px" }}>
              * {i18n.t("YouCanSeeTheScenesYouHaveRecorded")}
            </p>
          </Col>
        </Row>
        <Alert
          className="pageModal"
          show={this.state.showAlert}
          hasHeader
          acceptButtonText={i18n.t("OK")}
          title={i18n.t("error.warning")}
          closeButton
          onClose={() => {
            this.setState({ showAlert: false, alertMsg: "" });
          }}
        >
          <h4 style={{ marginBottom: "0px" }}> {this.state.alertMsg} </h4>
        </Alert>
      </AppModal>
    );
  }

  componentDidMount() {
    window.addEventListener("keyup", this.toggleModal);
  }

  componentWillUnmount() {
    window.removeEventListener("keyup", this.toggleModal);
  }

  toggleModal(e) {
    let key = e.keyCode ? e.keyCode : e.which;
    if (key === 27 && this.props.visible) {
      this.props.onUploadTemplateModalToggled();
    }
  }

  toggleTemplatesModal() {
    this.setState((prevState, props) => ({
      showTemplates: !prevState.showTemplates,
    }));
  }
  templateClick(boxes) {
    this.setState({
      boxes: boxes,
    });
  }

  restoreDefaultTemplate() {
    this.setState({
      boxes: [],
    });
  }
}

UploadTemplateModal.propTypes = {
  //navItemSelected: PropTypes.any.isRequired,
  /**
   * Selected contained view
   */
  containedViewSelected: PropTypes.any.isRequired,
  /**
   * Object containing all contained views (identified by its ID)
   */
  containedViews: PropTypes.object.isRequired,
  /**
   * Object containing all views (by id)
   */

  visible: PropTypes.any.isRequired,
  /**
   * Mark currently being edited
   */

  onUploadTemplateModalToggled: PropTypes.any.isRequired,
  /**
   * Cursor value when creating mark (coordinates)
   */

  onIndexSelected: PropTypes.func,
  /**
   * Contains the id of the selected template
   */
  indexSelected: PropTypes.func,
};
